import { DateTime } from 'luxon'

export const FIRST_BALANCE_CHANGE_CAPTURED = DateTime.fromISO(
  '2024-07-30T20:14:04.960Z'
)

export const FIRST_ELIGIBLE_REPORTING_PERIOD = '2024-08'
